import { Component, Input } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { FileProvider } from '../../providers/file/file';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthProvider } from '../../providers/auth/auth';
import { AssetProvider } from '../../providers/asset/asset';
import { Localfile } from '../../interfaces/localfile.modal';
import { LocalfileProvider } from '../../providers/localfile/localfile';


@Component({
  selector: 'local-file',
  templateUrl: 'local-file.html'
})
export class LocalFileComponent {

  @Input() localfile: Localfile;
  @Input() displaylist: boolean;

  assetClass: any;
  thumbnailDirPath: string;
  assetPaths: {assetPath: string, assetHTML: string};
  localfileType: string;
  openLocalfile: Localfile;
  

  constructor(
    public navCtrl: NavController,
    public assetService: AssetProvider,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public sanitizer: DomSanitizer,
    public fileService: FileProvider,
    public authService: AuthProvider,
    public localfileService: LocalfileProvider) {
    this.localfileType = "PDF FORM";
    this.openLocalfile = null;
  }

  tapFile(localfile, event){
    event.stopPropagation();
    this.showFile(localfile);
  }

  showFile(localfile){
    let toolbarBtnItems: (string|object)[] = ["thumbnails", "search", "annotation"];
    if(localfile.IsSharable) {
      toolbarBtnItems.push("email", "openIn", "print");
    }
    this.openPDFAsset(localfile, toolbarBtnItems);
  }

  getAssetThumbPath(localfile){
    if(localfile.thumbnail == null) { return false; }
    let safeUrl = this.fileService.getThumbAssetUrl(localfile.thumbnail);
    return this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl);
  }

  openPDFAsset(localfile, toolbarBtnItems){
    let fileName = localfile.fileName;
    console.log('openPDFAsset: ',fileName);
    const ext = fileName.substr(fileName.lastIndexOf('.') + 1);
    if(ext == 'pdf'){
      this.fileService.readFile(localfile.fileName, "localfiles").then((bool: boolean) => {
        this.openLocalfile = localfile;
        var path = this.fileService.getLocalFileUrl(localfile.fileName);
        console.log('openPDFAsset: path: ',path);
        PSPDFKit.present(path, { disableAutomaticSaving: false, pageMode: 'single'});
        PSPDFKit.setRightBarButtonItems(toolbarBtnItems);
        PSPDFKit.addEventListener('willDismiss', this.pspdfkitWillDismiss);
      }).catch(error => {
        this.showPopupNoAssetFile(localfile);
      });
    } else {
      console.log('openPDFAsset: extension error: ',ext);
      this.translate.get(['ERROR.FILE_TYPE_ERROR_TITLE', 'ERROR.FILE_TYPE_ERROR_TEXT']).subscribe(text => {
        this.displayPopupMessage(text["ERROR.FILE_TYPE_ERROR_TITLE"], text["ERROR.FILE_TYPE_ERROR_TEXT"]);
      });
    }
  }

  pspdfkitWillDismiss = (event) => {
    console.log("willDismiss event: "+ event);
    this.popupRemoveLocalFile();
    PSPDFKit.removeEventListener('willDismiss', this.pspdfkitWillDismiss);
  }


  showPopupNoAssetFile(localfile){
    this.translate.get(['ERROR.NO_ASSET_FILE_TITLE', 'ERROR.BAD_ASSET', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {
      const noAssetFilePopup = this.alertCtrl.create({
        title: text["ERROR.NO_ASSET_FILE_TITLE"],
        message: text["ERROR.BAD_ASSET"],
        buttons: [
          {
            text: text["GENERAL.NO"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: text["GENERAL.YES"]
          }
        ]
      });
      noAssetFilePopup.present();
    });
  }

  displayPopupMessage(title, message){
    const popup = this.alertCtrl.create({
      title: title,
      message: message,
      buttons: ['OK']
    });
    popup.present();
  }

  popupRemoveLocalFile(){
    this.translate.get(['LOCALFILE.DELETE_TITLE', 'LOCALFILE.DELETE_TEXT', 'GENERAL.YES', 'GENERAL.NO']).subscribe(text => {
      const popup = this.alertCtrl.create({
        title: text["LOCALFILE.DELETE_TITLE"],
        message: text["LOCALFILE.DELETE_TEXT"],
        buttons: [
          {
            text: text["GENERAL.NO"],
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: text["GENERAL.YES"],
            handler: data => {
              this.removeOpenedLocalFile();
            }
          }
        ]
      });
      popup.present();

    });
  }

  removeOpenedLocalFile(){
    this.fileService.removeFile(this.openLocalfile.fileName, "localfiles")
    .then(res => {
      console.log(res);
      this.localfileService.removeLocalfile(this.openLocalfile);
      this.openLocalfile = null;
    })
    .catch(err => console.log("error removeOpenedLocalFile: "+ err))
  }

  setThumbClass(localfile){
    if(localfile.thumbnail == null) { 
      return false; 
    } else {
        let thumbDisplay = "";
        if(localfile.ThumbnailWidth !== null && localfile.ThumbnailHeight !== null)
        {
          if (localfile.ThumbnailWidth < localfile.ThumbnailHeight){
            thumbDisplay = "portrait";
          } else {
            thumbDisplay = "";
          }
        }
        return thumbDisplay;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/local-file/local-file.ts